<template>
  <div>
    <a-col :sm="24" :md="10" style="margin-bottom: 16px">
      <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '108px', overflow: 'hidden'}">
        <div class="module-header-fs14">今日告警情况</div>
        <div style="display: flex; justify-content: space-around; flex-wrap: nowrap; margin-top: 5px">
          <a-statistic
            :value="todayAlert.newAlert"
            :valueStyle="{
              fontSize: '32px',
              lineHeight: '36px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.75)'
            }"
            style="margin: 0 16px 0 24px; color: rgba(0,0,0,.95)"
          >
            <div slot="title" style="font-size: 12px">
              <alert-icon style="color: #00b5ff; vertical-align: baseline"></alert-icon>
              今日新增告警
            </div>
          </a-statistic>

          <a-statistic
            :value="todayAlert.unrecovered"
            :valueStyle="{
              fontSize: '32px',
              lineHeight: '36px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.75)'
            }"
            style="margin: 0 16px 0 24px; color: rgba(0,0,0,.95)"
          >
            <div slot="title" style="font-size: 12px">
              <warning-icon style="color: #ff4d4f; vertical-align: baseline"></warning-icon>
              告警中
            </div>
          </a-statistic>
        </div>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="14" style="margin-bottom: 16px">
      <a-card :bordered="false" :body-style="{padding: '12px 16px', height: '108px',  overflow: 'hidden'}">
        <div class="module-header-fs14">今日告警工单处理情况</div>
        <div style="display: flex; justify-content: space-around; flex-wrap: nowrap; margin-top: 5px">
          <a-statistic
            :value="todayTicket.pending"
            :valueStyle="{
              fontSize: '32px',
              lineHeight: '36px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.75)'
            }"
            style="margin: 0 16px 0 24px; color: rgba(0,0,0,.95)"
          >
            <div slot="title" style="font-size: 12px">
              <ticket-status-icon style="color: #ff5b52; vertical-align: baseline" type="pending"></ticket-status-icon>
              待处理
            </div>
          </a-statistic>

          <a-statistic
            :value="todayTicket.processing"
            :valueStyle="{
              fontSize: '32px',
              lineHeight: '36px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.75)'
            }"
            style="margin: 0 16px 0 24px; color: rgba(0,0,0,.95)"
          >
            <div slot="title" style="font-size: 12px">
              <ticket-status-icon style="color: #69c66f; vertical-align: baseline" type="processing"></ticket-status-icon>
              处理中
            </div>
          </a-statistic>

          <a-statistic
            :value="todayTicket.processed"
            :valueStyle="{
              fontSize: '32px',
              lineHeight: '36px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.75)'
            }"
            style="margin: 0 16px 0 24px; color: rgba(0,0,0,.95)"
          >
            <div slot="title" style="font-size: 12px">
              <ticket-status-icon style="color: #bababa; vertical-align: baseline" type="processed"></ticket-status-icon>
              已处理
            </div>
          </a-statistic>
        </div>
      </a-card>
    </a-col>
  </div>
</template>

<script>
import moment from 'moment'
import { getAlertCount } from '@/api/alert.js'
import AlertIcon from '@/components/icon/AlertIcon.vue'
import WarningIcon from '@/components/icon/WarningIcon.vue'
import TicketStatusIcon from '@/components/icon/TicketStatusIcon.vue'

export default {
  name: 'AlertStatistic',
  components: {
    AlertIcon,
    WarningIcon,
    TicketStatusIcon
  },
  data () {
    return {
      params: {
        datetime_from: moment().format('YYYY-MM-DD 00:00'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm')
      },
      todayAlert: {
        newAlert: 0,
        unrecovered: 0
      },
      todayTicket: {
        pending: 0,
        processing: 0,
        processed: 0
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      getAlertCount(this.params).then(res => {
        if (res.data) {
          let total = 0
          res.data.data.forEach(item => {
            total += item.value
            if (item.name === 'unrecovered') this.todayAlert.unrecovered = item.value
          })
          this.todayAlert.newAlert = total
        } else {
          this.todayAlert = {
            newAlert: 0,
            unrecovered: 0
          }
        }
      })

      getAlertCount({
        ...this.params,
        count_of: 'ticket_state'
      }).then(res => {
        if (res.data) {
          for (const key in this.todayTicket) {
            if (Object.hasOwnProperty.call(this.todayTicket, key)) {
              const v = res.data.data.find(item => item.name === key)
              if (v) this.todayTicket[key] = v.value
            }
          }
        } else {
          this.todayTicket = {
            pending: 0,
            processing: 0,
            processed: 0
          }
        }
      })
    }
  }
}
</script>
